// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"bb426723","213":"86d4a2d1","531":"3b01b876","586":"bf3e4973","684":"68f2c52c"}[chunkId] + ".chunk.js";
};